<template>
    <div class="users-style">
        

        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>        

        <div class="row no-gutters py-2 mb-3 pl-0 border-bottom">
            <div class="col-sm-6">
                <div class="custom-search">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search User" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title">
                <b-button id="show-btn" @click="addNew()"><b-icon icon="plus" ></b-icon> New Admin User</b-button>
                <b-button @click="showTeamAllocation()"><b-icon icon="diagram3" ></b-icon> Team Allocation</b-button>
            </div>
        </div>
        
        
        <table class="table dataTable"> 
           
            <thead>
                <!--<tr class="table-head">                    
                    <td class="border-0">Name</td><td class="border-0">Email</td><td class="border-0">Phone</td><td class="border-0">Access Level</td><td class="border-0 text-right">Action</td>                   
                </tr>-->

                <tr class="table-head">
                    <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
                    <th class="text-right">Actions</th>
                </tr>
            </thead>            
            <tbody>
                <tr class="hover-bg table-row border-bottom mx-2" v-for="user in paginatedData" :key="user.id">                    
                    <td>{{user.name}}</td>
                    <td>{{user.email}}</td>
                    <td><template v-if="user.phone">{{formatPhoneNumber(user.phone)}}</template></td>
                    <!--<td>
                        <span v-if="user.user_level == 1">Super Admin</span>
                        <span v-else-if="user.user_level == 2">Admin</span>
                        <span v-else-if="user.user_level == 3">Manager</span>
                        <span v-else>Officer</span>
                    </td>-->
                    <td>{{all_user_level[user.user_level].text}}</td>
                    <td>
                        
                        <div class="float-right position-relative">
                            <b-button-toolbar>
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button-group >                               
                                        <b-button variant="outline-secondary"  @click="editUser(user.id)">
                                            <b-icon icon="pencil"></b-icon> Edit
                                        </b-button>  
                                        <b-button class="rounded delete-btn" title="Delete Department" @click="deleteUser(user.id)">
                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                        </b-button>                          
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                        </div>
                    </td>
                </tr>
                <tr v-if="paginatedData.length > 0"><td :colspan=6>
                <div class="row p-2 float-right" >
                    <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                </div></td></tr>
                <tr v-if="paginatedData.length == 0"><td :colspan=6>{{blankmsg}}</td></tr>
            </tbody>
        </table>

        <b-modal id="bv-modal-team-allocation" dialog-class="modal-xxl modal-overflow" body-class="pt-0" header-class="mb-2" size="lg" hide-footer title="Team Allocation">
            <system-team-allocation ></system-team-allocation>
        </b-modal>
        <b-modal id="bv-modal-example" size="lg" hide-footer title="User Details">
            <ul class="list-group mb-3 " v-if='errormsg'>           
                <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
            </ul>
                    
            
            <b-overlay :show="showoverlay" rounded="sm">
            <b-form @submit.stop.prevent="onSubmit">
                <input type="hidden" v-model="fdata.id" name="id">

                <b-form-group id="name-group" class="half-width mr1" label="Name" label-for="name">
                    <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="email-group" class="half-width" label="Email" label-for="email">
                    <b-form-input id="email" name="email" type="email" v-model="fdata.email" v-validate="{ required: true, min: 3 , email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                    <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                </b-form-group>


                <b-form-group id="phone-group" label="Phone" class="required-field half-width mr1" label-for="phone">                            
                    <b-input-group prepend="+880">                            
                        <b-form-input id="phone" name="phone" v-model="fdata.phone" v-validate="{ required: true, min: 10 , max:10 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Phone"></b-form-input>
                        <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>

                <b-form-group id="user_level-group" class="half-width" label="Access Level" label-for="user_level">
                    <b-form-select id="user_level" name="user_level" v-model="fdata.user_level" v-validate="{ required: true }" :options="user_level" :state="validateState('user_level')" aria-describedby="user_level-feedback" data-vv-as="Access Level"></b-form-select>
                    <b-form-invalid-feedback id="user_level-feedback">{{ veeErrors.first('user_level') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="assigned_companies-group" class="half-width mr1" label="Assigned Companies" label-for="assigned_companies" v-if="fdata.user_level > 2">                    
                    <b-form-select id="assigned_companies" name="assigned_companies" v-model="fdata.assigned_companies" multiple :select-size="10">
                        <b-form-select-option :value="null">Select...</b-form-select-option>
                        <b-form-select-option-group v-for="agent in companies" :label="agent.name" :key="agent.id">
                            <b-form-select-option v-for="company in agent.companies" :key="company.value" :value="company.value" :label="company.text"></b-form-select-option>
                        </b-form-select-option-group>
                    </b-form-select>
                </b-form-group>                

                <b-form-group id="status-group" label="Status" class="half-width" label-for="status">
                    <b-form-select id="status" name="status" v-model="fdata.status" v-validate="{ required: true }" :options="status" :state="validateState('status')" aria-describedby="status-feedback" data-vv-as="Status"></b-form-select>
                    <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
                </b-form-group>

                <div class="d-none">
                    <b-form-group id="change_password-group" class="half-width" style="margin-left: -1%" label-for="change_password" v-if="edit_user">
                        <b-form-checkbox id="change_password"  v-model="fdata.change_password" name="change_password" value="change_password">
                            Change Password
                        </b-form-checkbox>
                    </b-form-group>
                    
                    <b-form-group id="password-group" label="Password" class="half-width" style="margin-left: -1%" label-for="password" v-if="fdata.change_password">
                        <b-form-input id="password" name="password" type="password" v-model="fdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                        <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="password_confirmation-group" class="half-width" label="Confirm Password" label-for="password_confirmation" v-if="fdata.change_password">
                        <b-form-input id="password_confirmation" name="password_confirmation" type="password" v-model="fdata.password_confirmation" v-validate="{ required: true, confirmed: fdata.password }" :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback" data-vv-as="Confirm Password"></b-form-input>
                        <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
                    </b-form-group>
                </div>

              <div class="full-width">
                <b-button type="submit" variant="success">Submit</b-button>
              </div>
            </b-form>
            </b-overlay>

        </b-modal>
    </div>
</template>


<script>
    export default{
        props: ['this_user_level'],        
        
        data(){
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Email', name: 'email'},
                            {label: 'Phone', name: 'phone'},
                            {label: 'Access Level', name: 'user_level'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {
                disableme : false,
                users : [],
                companies : [],                
                successmsg:'',
                errormsg:[],
                fdata: {id:null, email: null, password:'pass1234' , password_confirmation:'pass1234' , user_level:null, change_password:true, status:null, assigned_companies : [] },
                user_level: [],
                all_user_level : [{ value: null, text: "Select..." },
                    { value: "1", text: "Super Admin" },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Executive" }],
                status: [
                    { value: null, text: "Select..." },
                    { value: "0", text: "Disabled" },
                    { value: "1", text: "Enabled" },
                ],
                edit_user:false,
                

                showoverlay : false,

                blankmsg : 'Fetching data..',

                search : '',

                columns: columns,
                sortKey: 'name',
                sortOrders: sortOrders,
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                    
                    id:null, email: null, password:'pass1234'  , password_confirmation:'pass1234' , user_level:null, change_password:true, status:null , assigned_companies:[]
                };

                this.disableme = false;

                this.errormsg = [];

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            showTeamAllocation()
            {
                this.$bvModal.show('bv-modal-team-allocation');                
            },
            addNew()
            {
                this.resetForm();
                this.edit_user = false,
                this.disableme = false;
                this.$bvModal.show('bv-modal-example');
            },
            editUser:function(x)
            {         
                this.resetForm();
                axios.get(this.$api_url+'/getadmin' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.fdata.phone = response.data.phone.slice(3,15);
                    this.edit_user = true;
                    this.disableme = true;
                    this.$validator.reset();
                }.bind(this));
                this.$bvModal.show('bv-modal-example');
                
            },
            getCompanies: function(){
                axios.get(this.$api_url+'/companies/all')
                .then(function (response) {                    
                        this.companies = response.data            
                }.bind(this));
         
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }                 

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        console.log(`${key}: ${value}`);
                    } 

                    this.showoverlay = true; 

                    axios.post(this.$api_url+'/save-admin', formData, config)
                                .then(function (response) 
                                {
                                    this.$bvToast.toast("Saved", {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                    this.getAllAdmin();
                                    this.$bvModal.hide('bv-modal-example');                                    
                                    this.resetForm();                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.errormsg = error.response.data.errors;
                                });

                    

                    this.showoverlay = false; 
                });
            }
            ,getAllAdmin: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/all-admin-user' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.users = response.data;
                    
                    if(this.users.length == 0)
                        this.blankmsg = "Nothing found.";

                    else
                        this.sortBy('name');
                }.bind(this));
            },
            deleteUser:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this user.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {                    
                    if(value)
                    {                        
                        this.resetForm();
                        let currentObj = this;
                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);
                        
                        axios.post(this.$api_url+'/admin-user/delete', formData).then(function(response){
                            
                            this.getAllAdmin();
                            this.showoverlay = false;
                            
                        }.bind(this))
                        .catch(function (error) 
                        {
                            currentObj.serverError(error);
                        });
                    }
                })
                .catch(err => {
                    // An error occurred
                })    
            },  
            

        },
        created: function(){

            if(this.this_user_level == 1)
            {
                this.user_level = [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Super Admin" },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Executive" },
                ];

                
            }
            else if(this.this_user_level == 2)
            {
                this.user_level = [
                    { value: null, text: "Select..." },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Executive" },
                ];
                // this.user_level = [
                //     { value: null, text: "Select..." },
                //     { value: "1", text: "Super Admin" },
                //     { value: "2", text: "Admin" },
                //     { value: "3", text: "Manager" },
                //     { value: "4", text: "Executive" },
                // ];
            }

            this.getAllAdmin();
            this.getCompanies();
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.users;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            else if (this.columns[index].type && this.columns[index].type === 'number') 
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
